import { FIVE_STAR_SCALE } from '../constants';
import { ratingToStars } from '../utils';

type StrengthMeterProps = {
  attack: number;
  defence: number;
};

const SEGMENT_WIDTH = 6;
const FILLED_COLOUR = '#009DE5';
const HALF_FILL_PERCENT = 50;

const Meter = ({ label, rating }: { label: string; rating: number }) => {
  const stars = ratingToStars(rating);

  return (
    <span
      className="inline-flex items-center gap-1"
      title={`${
        label === 'ATT' ? 'Attack' : 'Defence'
      } strength ${stars} / ${FIVE_STAR_SCALE}`}
    >
      <span className="font-open-sans text-[9px] font-semibold uppercase tracking-wide text-neutral-500">
        {label}
      </span>
      <span className="inline-flex gap-px">
        {Array.from({ length: FIVE_STAR_SCALE }, (_, index) => {
          const fill = Math.min(Math.max(stars - index, 0), 1);
          return (
            <span
              key={index}
              className="relative h-1.5 overflow-hidden rounded-[1px] bg-neutral-200"
              style={{ width: SEGMENT_WIDTH }}
            >
              {fill > 0 && (
                <span
                  className="absolute inset-y-0 left-0"
                  style={{
                    width: `${fill === 1 ? 100 : HALF_FILL_PERCENT}%`,
                    backgroundColor: FILLED_COLOUR
                  }}
                />
              )}
            </span>
          );
        })}
      </span>
    </span>
  );
};

// Compact attack/defence strength shown under the team name when "Team
// strength" is on, so the grid does not shift to make room for extra columns.
export const StrengthMeter = ({ attack, defence }: StrengthMeterProps) => (
  <span
    className="inline-flex items-center gap-2"
    data-testid="team-strength-meter"
  >
    <Meter label="ATT" rating={attack} />
    <Meter label="DEF" rating={defence} />
  </span>
);
